module.exports = __webpack_public_path__ + "img/0d7922a.jpg";